import { request } from '@/common/utils/request'
export function getMapShopList(params) {
  // 绩效考核方案指标项下发
  return request
    .post({
      url: 'feidian.gas.bizopp.bdapp.getMapList',
      params,
    })
    .then(res => res.data)
}
